import { render, staticRenderFns } from "./PagesSeo.vue?vue&type=template&id=44d2f65b&"
import script from "./PagesSeo.vue?vue&type=script&lang=js&"
export * from "./PagesSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports